export default __webpack_public_path__ + "static/cloudServicesBanner-714e0ca337e51a41751f8b8e3fd09d8e.svg";